import dynamic from 'next/dynamic'
import STYLE_CONSTANTS from '~/style/constants'

const PAYMENT_DETAILS_CONFIGURATION = {
  slug: 'payment-details',
  Component: dynamic(() => import('./index')),
  progressBarColor: STYLE_CONSTANTS.colors.primary.green,

  // eslint-disable-next-line
  onEnter: async self => {
    // This step can be skiped to by attroney select screen if only 1 attorney. so onEnter event wont fire. do not use this. it will only fire for cases when more than one attorney .
  },
  // eslint-disable-next-line
  onExit: async self => {
    return true // to allow continue
  }
}

export default PAYMENT_DETAILS_CONFIGURATION
